import type { FilePickerCropperOptions } from '@commons/bo-ui/form/file-picker/models/file-picker-options.interface';
import type { ImageCroppedEvent } from 'ngx-image-cropper';

import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { BehaviorSubject } from 'rxjs';

export interface DialogData {
  image: File;
  type: string;
  name: string;
  cropperOptions?: FilePickerCropperOptions;
}

@Component({
  selector: 'app-crop-dialog',
  templateUrl: './crop-dialog.component.html',
  styleUrls: ['./crop-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageCropperComponent, MatProgressSpinner, MatButton, AsyncPipe],
})
export class CropDialogComponent {
  readonly #dialogRef = inject(MatDialogRef<CropDialogComponent>);
  readonly data: DialogData = inject(MAT_DIALOG_DATA);

  croppedImage!: string;
  fileError = false;
  loading$ = new BehaviorSubject<boolean>(true);
  cropperOptions: FilePickerCropperOptions;

  constructor() {
    this.cropperOptions = this.data.cropperOptions ? this.data.cropperOptions : { aspectRatio: 1 };
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64!;
  }

  cropperReady(): void {
    this.loading$.next(false);
  }

  loadImageFailed(): void {
    this.fileError = true;
  }

  async onSubmit(): Promise<void> {
    const croppedFile = await (await fetch(this.croppedImage)).blob();
    this.#dialogRef.close(new File([croppedFile], this.data.name, { type: this.data.image.type }));
  }

  onClose(): void {
    this.#dialogRef.close(null);
  }
}
